export default __webpack_public_path__ + "static/app_preview-f08e6c80165f6fcf51b3e48b7f7ad9ae.png";